import { useEffect } from 'react';

const StructuredData = ({ project }) => {
  useEffect(() => {
    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "EvoCore PACA",
      "url": "https://www.evocore-paca.fr",
      "logo": "https://www.evocore-paca.fr/logo512.png",
      "description": "Plateforme d'intelligence artificielle pour accompagner les auto-entrepreneurs de la région PACA",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "Provence-Alpes-Côte d'Azur",
        "addressCountry": "FR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "43.7102",
        "longitude": "7.2620"
      },
      "areaServed": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "43.7102",
          "longitude": "7.2620"
        },
        "geoRadius": "100000"
      },
      "sameAs": [
        "https://www.linkedin.com/company/evocore-paca",
        "https://twitter.com/evocorepaca"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Service",
        "email": "contact@evocore-paca.fr",
        "availableLanguage": ["French"]
      }
    };

    // LocalBusiness Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "EvoCore PACA",
      "image": "https://www.evocore-paca.fr/logo512.png",
      "description": project?.description || "Solutions IA pour auto-entrepreneurs",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "Provence-Alpes-Côte d'Azur",
        "addressCountry": "FR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "43.7102",
        "longitude": "7.2620"
      },
      "url": "https://www.evocore-paca.fr",
      "telephone": "+33-XXX-XXX-XXX",
      "priceRange": "$$",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "09:00",
        "closes": "18:00"
      }
    };

    // SoftwareApplication Schema
    const softwareSchema = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "EvoCore PACA",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "EUR"
      },
      "description": "Plateforme IA pour la transformation numérique des auto-entrepreneurs",
      "featureList": [
        "Intelligence Artificielle",
        "Génération de contenu",
        "Analyse de données",
        "Gestion de projet"
      ],
      "screenshot": "https://www.evocore-paca.fr/screenshot.png"
    };

    // WebSite Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "EvoCore PACA",
      "url": "https://www.evocore-paca.fr",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://www.evocore-paca.fr/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    };

    // BreadcrumbList Schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Accueil",
          "item": "https://www.evocore-paca.fr"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Projet",
          "item": "https://www.evocore-paca.fr/#projet"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Contact",
          "item": "https://www.evocore-paca.fr/#contact"
        }
      ]
    };

    // Combine all schemas
    const allSchemas = [
      organizationSchema,
      localBusinessSchema,
      softwareSchema,
      websiteSchema,
      breadcrumbSchema
    ];

    // Remove existing script if any
    const existingScript = document.getElementById('structured-data');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new script
    const script = document.createElement('script');
    script.id = 'structured-data';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(allSchemas);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById('structured-data');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [project]);

  return null;
};

export default StructuredData;
